import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { B as Button } from '../../Button/Button-BzSULnj6.js';
import { T as Text } from '../../Text/Text-DvcofqkP.js';
import { M as Modal } from '../../Modal/Modal-hhc8oCzq.js';
import { U as UnorderedList } from '../../List/UnorderedList-LgxT_xiH.js';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { S as StyledListItem } from '../../List/ListItem/ListItem-C98zUaGD.js';
import { T as TextButton } from '../../Button/TextButton/TextButton-B6fx5_Cq.js';

const textSize = 'base';
const CancelTextButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-40027066__sc-s0go2v-0"
})(["margin-right:", ";"], ({
  theme
}) => theme.spacing.base.default);
const WarningModal = ({
  cancelButtonProps,
  confirmButtonProps,
  isOpen,
  label,
  onCancel,
  onConfirm,
  toggleEl
}) => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: isOpen,
    hasCloseButton: false,
    footer: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CancelTextButton, _extends({}, cancelButtonProps, {
      onClick: onCancel
    }), formatMessage({
      id: 'cancel_button_label'
    })), /*#__PURE__*/React__default.createElement(Button, _extends({}, confirmButtonProps, {
      onClick: onConfirm
    }), label)),
    onClose: onCancel,
    toggleEl: toggleEl
  }, /*#__PURE__*/React__default.createElement(Text, {
    size: textSize
  }, formatMessage({
    id: 'warning_header'
  })), /*#__PURE__*/React__default.createElement(UnorderedList, null, /*#__PURE__*/React__default.createElement(StyledListItem, null, /*#__PURE__*/React__default.createElement(Text, {
    size: textSize
  }, formatMessage({
    id: 'warning_body_list_item_one'
  }))), /*#__PURE__*/React__default.createElement(StyledListItem, null, /*#__PURE__*/React__default.createElement(Text, {
    size: textSize
  }, formatMessage({
    id: 'warning_body_list_item_two'
  })))), /*#__PURE__*/React__default.createElement(Text, {
    size: textSize
  }, formatMessage({
    id: 'warning_footer'
  })));
};

export { WarningModal as W };
//# sourceMappingURL=WarningModal-CXeQ-x3S.js.map
